export default "__VITE_ASSET__LJ1Fda2D__"